<template>
  <el-dialog
    class="rc-dialog"
    title="编辑座位号"
    :visible.sync="showTrainModal.flag"
    width="30%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="trainForm"
      ref="trainForm"
      >
      <el-row>
        <el-col :span="24">
          <el-form-item label="姓名：" prop="userName">
            <el-input
              v-model="trainForm.userName"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="座位号：" prop="seatNumber">
            <el-input
              v-model="trainForm.seatNumber"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { updateClassUserSeat } from "@/api/class";
import rulesFactory from "@/utils/rules";
export default {
  props: {
    showTrainModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    seatItem: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      rulesFactory,
      trainForm: {
        userName: "",
        courseId: "",
        enrollId: "",
        seatNumber: "",
        uuid: ""
      },
      rules: {
        seatNumber: [rulesFactory.size("最多输入50个字", 0, 50)],
      },
    };
  },
  created() {
    this.trainForm.userName = this.seatItem.userName;
    this.trainForm.courseId = this.seatItem.courseId;
    this.trainForm.enrollId = this.seatItem.enrollId;
    this.trainForm.seatNumber = this.seatItem.seatNumber;
    this.trainForm.uuid = this.seatItem.uuid;
  },
  methods: {
    cancel() {
      this.$emit("closeTrainModal");
    },
    submit() {
      this.$refs["trainForm"].validate().then(() => {
        let params = {
          ...this.trainForm,
        };
        updateClassUserSeat(params).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.cancel();
          this.$parent.reload();
        })
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    overflow: hidden;
    padding-bottom: 40px;
    .form-select {
      width: 80%;
    }
  }
  .wth_220 {
    width: 220px;
  }
}
</style>
